import React from "react";
import { useState } from "react";

const TopIcon = () => {
  const [animate, setAnimate] = useState(false);

  window.addEventListener("scroll", () => {
    window.scrollY > 100 ? setAnimate(true) : setAnimate(false);
  });

  const goTop  = () => {
    window.scrollTo({
        top:0,
        behavior : "smooth",
    })
  }

  return (
    <div className={`top-icon ${animate ? "animateIcon" : null}`} onClick={goTop} >
      <span className="icon-animation">
        <i className="fa fa-arrow-up"></i>
      </span>
    </div>
  );
};

export default TopIcon;
